import { ConversationMessageInput } from '@modules/conversation-message/ConversationMessageInput';
import { useConversationEditor } from '@modules/conversation/hooks/useConversationEditor';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MOBILE_BREAKPOINT } from 'src/config-global';
import { useConversationContext } from 'src/provider/ConversationContext';
import { useTableRowActivitiesContext } from './useTableRowActivitiesContext';

export const ActivitiesInput = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    padding: theme.spacing(2, 1.5),
  },
  '& .MuiInputBase-input': {
    padding: 0,
  },
  '& .replyto-container': {
    marginLeft: theme.spacing(1.5),
    '& .text': {
      minWidth: '188px',
    },
  },
}));

export const ActivitiesMessageInput = ({
  disabled,
}: { disabled?: boolean }) => {
  const { handleTextMessage, handleFileSelect, editorConfig, rowId } =
    useTableRowActivitiesContext();

  const { showInput } = useConversationContext();

  const { editor, editorLoaded } = useConversationEditor({
    conversationId: rowId,
    editorConfig,
  });

  if (!editorLoaded || !showInput) return null;

  return (
    <ActivitiesInput>
      <ConversationMessageInput
        allowAskAi={false}
        handleTextMessage={handleTextMessage}
        handleFileSelect={handleFileSelect}
        editor={editor}
        disabled={disabled}
        iconSize={20}
        allowOptions={false}
        allowSoundBoard={false}
      />
    </ActivitiesInput>
  );
};
